import React, { useState } from 'react';
import { CheckCircle2, ShieldOff, Lock } from 'lucide-react';
import { API, authFetch } from '../lib/api';

export default function LicenseVerifier() {
  const [loading, setLoading] = useState(false);
  const [result, setResult]   = useState(null);
  const [token, setToken]     = useState('');

  const verify = async () => {
    setLoading(true);
    try {
      const res  = await authFetch(`${API}/license/verify`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ licenseToken: token }) });
      const data = await res.json();
      setResult(data);
    } catch { alert('Verification Engine Error.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">System Verification Node</span>
        <span className="card-badge">BETA_DNA_VERIF_v1</span>
      </div>
      <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <label className="form-label">License Key / Token</label>
          <input className="form-input mono" value={token} onChange={e => setToken(e.target.value)} placeholder="VERIT-XXXXXXX..." data-testid="verify-token" />
        </div>
        {result && (
          <div className={`animate-fade-in alert-banner ${result.valid ? 'green' : 'red'}`}>
            {result.valid ? <CheckCircle2 size={14} color="#16a34a" style={{ flexShrink: 0, marginTop: 2 }} /> : <ShieldOff size={14} color="#dc2626" style={{ flexShrink: 0, marginTop: 2 }} />}
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: result.valid ? '#16a34a' : '#dc2626', marginBottom: 6 }}>
                {result.valid ? 'NODE_VERIFIED_AUTHENTIC' : 'VERIFICATION_FAILED_UNAUTHORIZED'}
              </div>
              {result.valid && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, fontSize: 11 }}>
                  <div><span style={{ color: '#94a3b8', fontSize: 9, fontWeight: 700, textTransform: 'uppercase' }}>Customer</span><div style={{ fontWeight: 700 }}>{result.customer}</div></div>
                  <div><span style={{ color: '#94a3b8', fontSize: 9, fontWeight: 700, textTransform: 'uppercase' }}>Expiry</span><div style={{ fontWeight: 700, color: '#3b82f6' }}>{result.expires}</div></div>
                </div>
              )}
            </div>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn btn-dark" onClick={verify} disabled={loading || !token} data-testid="verify-btn">
            {loading ? 'Decrypting Root DNA...' : <><Lock size={13} /> Verify System Node</>}
          </button>
        </div>
      </div>
    </div>
  );
}
